export default __webpack_public_path__ + "static/media/Ltst-2.4d1213ab.jfif";